export const dataId = 'dashboards.dashboards';

const dashboards = 'dashboards';
const dashboard = 'dashboard';
const createModal = `${dashboard}.createModal`;
const linkModal = `${dashboard}.linkModal`;
const deleteModal = `${dashboard}.deleteModal`;
const pinModal = `${dashboard}.pinModal`;
const unpinModal = `${dashboard}.unpinModal`;
const duplicateModal = `${dashboard}.duplicateModal`;
const editNameModal = `${dashboard}.editNameModal`;
const confirmChangesModal = `${dashboard}.confirmChangesModal`;
const editHeader = `${dashboard}.editHeader`;
const widget = 'widget';
const addWidget = 'addWidget';
const sidePanel = `${addWidget}.sidePanel`;
const dashboardLink = 'dashboardLink';
const dashboardAccess = 'dashboardAccess';
const table = `${dashboards}.table`;

export default {
    home: {
        profile: 'home.profile',
    },
    dashboards: {
        actions: {
            create: `${dashboards}.create`,
        },
        table: {
            actions: {
                star: `${table}.star`,
            },
        },
    },
    dashboard: {
        returnToDashboards: `${dashboard}.returnToDashboards`,
        actions: {
            edit: `${dashboard}.edit`,
            link: `${dashboard}.link`,
            delete: `${dashboard}.delete`,
            share: `${dashboard}.share`,
            pin: `${dashboard}.pin`,
            unpin: `${dashboard}.unpin`,
            duplicate: `${dashboard}.duplicate`,
        },
        createModal: {
            inputName: `${createModal}.inputName`,
            actions: {
                save: `${createModal}.save`,
                cancel: `${createModal}.cancel`,
                tryAgain: `${createModal}.tryAgain`,
            },
        },
        linkModal: {
            actions: {
                bulk: `${linkModal}.bulk`,
                copy: `${linkModal}.copy`,
                cancel: `${linkModal}.cancel`,
                tryAgain: `${linkModal}.tryAgain`,
                reset: `${linkModal}.reset`,
            },
        },
        deleteModal: {
            actions: {
                delete: `${deleteModal}.delete`,
                cancel: `${deleteModal}.cancel`,
                tryAgain: `${deleteModal}.tryAgain`,
            },
        },
        pinModal: {
            actions: {
                pin: `${pinModal}.pin`,
                cancel: `${pinModal}.cancel`,
                tryAgain: `${pinModal}.tryAgain`,
            },
        },
        unpinModal: {
            actions: {
                unpin: `${unpinModal}.unpin`,
                cancel: `${unpinModal}.cancel`,
                tryAgain: `${unpinModal}.tryAgain`,
            },
        },
        duplicateModal: {
            inputName: `${duplicateModal}.inputName`,
            actions: {
                duplicate: `${duplicateModal}.duplicate`,
                cancel: `${duplicateModal}.cancel`,
                tryAgain: `${duplicateModal}.tryAgain`,
            },
        },
        editHeader: {
            actions: {
                addWidget: `${editHeader}.addWidget`,
                editLayout: `${editHeader}.editLayout`,
                saveLayout: `${editHeader}.saveLayout`,
                exitEditMode: `${editHeader}.exitEditMode`,
            },
        },
        editNameModal: {
            inputName: `${editNameModal}.inputName`,
            actions: {
                save: `${editNameModal}.save`,
                cancel: `${editNameModal}.cancel`,
                tryAgain: `${deleteModal}.tryAgain`,
            },
        },
        confirmChangesModal: {
            inputName: `${confirmChangesModal}.inputName`,
            actions: {
                saveAndProceed: `${confirmChangesModal}.save`,
                proceed: `${confirmChangesModal}.proceed`,
                cancel: `${confirmChangesModal}.cancel`,
                tryAgain: `${confirmChangesModal}.tryAgain`,
            },
        },
    },
    widget: {
        notEditable: `${widget}.notEditable`,
        editable: `${widget}.editable`,
        actions: {
            delete: `${widget}.delete`,
            edit: `${widget}.edit`,
        },
        deleteModal: {
            actions: {
                delete: `${deleteModal}.delete`,
                cancel: `${deleteModal}.cancel`,
                tryAgain: `${deleteModal}.tryAgain`,
            },
        },
    },
    addWidget: {
        sidePanel: {
            actions: {
                back: `${sidePanel}.back`,
                close: `${sidePanel}.close`,
                save: `${sidePanel}.save`,
            },
            form: {
                select: `${sidePanel}.select`,
            },
        },
    },
    dashboardLink: {
        actions: {
            fullscreen: `${dashboardLink}.fullscreen`,
        },
    },
    dashboardAccess: {
        actions: {
            tryAgain: `${dashboardAccess}.tryAgain`,
            save: `${dashboardAccess}.save`,
            cancelSave: `${dashboardAccess}.cancelSave`,
        },
    },
};
